import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Dashboard from "../views/Dashboard.vue";
import TestAccountCreator from "../views/TestAccountCreator.vue";
import Transactions from "../views/Transactions.vue";
import TransactionsMyST from "../views/TransactionsMyST.vue";
import TransactionsCybersource from "../views/TransactionsCybersource.vue";
import TransactionsGourmetGulf from "../views/TransactionsGourmetGulf.vue";
import TransactionsNiPos from "../views/TransactionsNiPos.vue";
import eTerminal from "../views/eTerminal.vue";
import Reports from "../views/Reports.vue";
import AddClient from "../views/AddClient.vue";
import SearchClient from "../views/SearchClient.vue";
import Client from "../views/Client.vue";
import RegByLink from "../views/RegByLink.vue";
import RegByLinkCNP from "../views/RegByLinkCNP.vue";
import RegPaySchByLink from "../views/RegPaySchByLink.vue";
import PayByLink from "../views/PayByLink.vue";
import PayByLinkPayment from "../views/PayByLinkPayment.vue";
import PayByLinkPaymentCNP from "../views/PayByLinkPaymentCNP.vue";
import OnBoarder from "../views/OnBoarder.vue";
import AddIntegration from "../views/AddIntegration.vue";
import ViewIntegrations from "../views/ViewIntegrations.vue";
import AddUser from "../views/AddUser.vue";
import EditUser from "../views/EditUser.vue";
// import Credentials from "../views/Credentials.vue";
import Chargebacks from "../views/Chargebacks.vue";
import ChargebacksDefender from "../views/ChargebacksDefender.vue";
import ChargebackContacts from "../views/ChargebackContacts.vue";
import SofortTest from "../views/SofortTest.vue";
import RiskAlerts from "../views/RiskAlerts.vue";
import store from "../store.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    beforeEnter(to, from, next) {
      if (!store.state.user) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/logout",
    name: "Logout",
    component: Login,
    beforeEnter(to, from, next) {
      if (store.state.user) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    beforeEnter(to, from, next) {
      if (store.state.user) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/transactions",
    name: "Transactions",
    component: Transactions,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id <= 6) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/transactions-my-st",
    name: "TransactionsMyST",
    component: TransactionsMyST,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id == 1) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/transactions-cs",
    name: "TransactionsCybersource",
    component: TransactionsCybersource,
    beforeEnter(to, from, next) {
      if (
        store.state.user &&
        [1, 2, 8].includes(store.state.user.user_role.id)
      ) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/transactions-gourmet-gulf",
    name: "TransactionsGourmetGulf",
    component: TransactionsGourmetGulf,
    beforeEnter(to, from, next) {
      if (store.state.user && [1, 9].includes(store.state.user.user_role.id)) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/transactions-ni-pos",
    name: "TransactionsNiPos",
    component: TransactionsNiPos,
    beforeEnter(to, from, next) {
      if (store.state.user) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/chargebacks",
    name: "Chargebacks",
    component: Chargebacks,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id <= 2) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/chargeback-contacts",
    name: "ChargebackContacts",
    component: ChargebackContacts,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id <= 3) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/chargebacks-defender",
    name: "ChargebacksDefender",
    component: ChargebacksDefender,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id <= 5) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/risk-alerts",
    name: "RiskAlerts",
    component: RiskAlerts,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id <= 5) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/eterminal",
    name: "eTerminal",
    component: eTerminal,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id != 8) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/reports",
    name: "Reports",
    component: Reports,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id <= 5) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/add-client",
    name: "AddClient",
    component: AddClient,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id <= 4) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/search-client",
    name: "SearchClient",
    component: SearchClient,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id <= 4) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/client:id",
    name: "Client",
    component: Client,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id <= 4) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/pay-by-link",
    name: "PayByLink",
    component: PayByLink,
    beforeEnter(to, from, next) {
      let merchArr = [];
      if (store.state.user.user_role.id > 3) {
        let merchants = store.state.user.merchant_access
          .replace("[", "")
          .replace("]", "")
          .replace(/"/gi, "");
        merchArr = merchants.split(",");
      }

      if (
        (store.state.user && store.state.user.user_role.id <= 5) ||
        (store.state.user.user_role.id <= 6 &&
          (merchArr.includes("8acda4cb7401359d0174540973c84c4d") ||
            merchArr.includes("8ac9a4c8747f30650174968e8456706d"))) ||
        (store.state.user.user_role.id == 7 &&
          merchArr.includes("8ac9a4c879410c54017979be8d1a15cb")) ||
        (store.state.user.user_role.id == 7 &&
          merchArr.includes("8ac9a4c7798e61ed0179a3812feb26a8"))
      ) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/pay-by-link-payment/:id",
    name: "PayByLinkPayment",
    component: PayByLinkPayment,
    beforeEnter(to, from, next) {
      next();
    },
  },
  {
    path: "/pay-by-link-payment-cnp/:id",
    name: "PayByLinkPaymentCNP",
    component: PayByLinkPaymentCNP,
    beforeEnter(to, from, next) {
      next();
    },
  },
  {
    path: "/onboarder",
    name: "OnBoarder",
    component: OnBoarder,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id <= 2) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/add-integration",
    name: "AddIntegration",
    component: AddIntegration,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id <= 3) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/view-integrations",
    name: "ViewIntegrations",
    component: ViewIntegrations,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id <= 3) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/add-user",
    name: "AddUser",
    component: AddUser,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id <= 5) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/edit-user",
    name: "EditUser",
    component: EditUser,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id <= 5) {
        next();
      } else {
        next("/login");
      }
    },
  },
  //   {
  //     path: '/credentials',
  //     name: 'Credentials',
  //     component: Credentials,
  //     beforeEnter(to, from, next) {
  //       if(store.state.user && store.state.user.user_role.id <= 5) {
  //         next();
  //       } else {
  //         next('/login');
  //       }
  //     }
  //   },
  {
    path: "/client/:id",
    name: "client",
    component: Client,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id <= 4) {
        let data = null;
        if (JSON.parse(store.state.user.merchant_access_test)) {
          data = {
            merchants: JSON.parse(store.state.user.merchant_access_test).concat(
              JSON.parse(store.state.user.merchant_access)
            ),
            id: to.params.id,
          };
        } else {
          data = {
            merchants: JSON.parse(store.state.user.merchant_access),
            id: to.params.id,
          };
        }

        store.dispatch("clientAccess", data).then((response) => {
          if (response) {
            next();
          } else {
            next("/search-client");
          }
        });
      }
      if (store.state.user && store.state.user.user_role.id <= 6) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/reg-by-link/:id",
    name: "RegByLink",
    component: RegByLink,
    beforeEnter(to, from, next) {
      next();
    },
  },
  {
    path: "/reg-by-link-cnp/:id",
    name: "RegByLinkCNP",
    component: RegByLinkCNP,
    beforeEnter(to, from, next) {
      next();
    },
  },
  {
    path: "/reg-pay-sch-link/:id",
    name: "RegPaySchByLink",
    component: RegPaySchByLink,
    children: [
      {
        path: "check-status",
        name: "RegPaySchByLinkCheckStatus",
      },
    ],
    beforeEnter(to, from, next) {
      next();
    },
  },
  {
    path: "/test-account-creator",
    name: "TestAccountCreator",
    component: TestAccountCreator,
    beforeEnter(to, from, next) {
      next();
    },
  },
  {
    path: "/sofort-test",
    name: "SofortTest",
    component: SofortTest,
    beforeEnter(to, from, next) {
      if (store.state.user && store.state.user.user_role.id == 1) {
        next();
      } else {
        next("/login");
      }
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  console.log("From: " + from.name);
  console.log("To:" + to.name);

  if (to.name == "Login" || to.name == "Logout" || from.name == "Logout") {
    console.log("login/logout page");
    next();
  } else {
    console.log("Hit");
    store.dispatch("autoLogin").then((response) => {
      if (response) {
        next();
      } else {
        next("/login");
      }
    });
  }
});

export default router;
